import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import { Button, Space } from 'antd';
import {
  SearchResultForCompany,
  SearchResultForCompanyUSDOT,
  SearchResultForFindSupport,
} from '../../../../../Utils/SearchResults';
import { supports } from '../../../../../API/TT_ELD/supports';
import SearchOptions from '../../../../../Utils/SearchOptions';
import { useDispatcher } from '../../../../../Hooks/TT_ELD/Supports';
import SupportUserTable from './SupportUserTable';
import { sendEvent } from '../../../../../Utils/analytics';
import { useTagQuerySync } from '../../../../../Utils/useTagQuerySync';
import useRouteQuery from '../../../../../Utils/useRouterQuery';

type numStr = number | string;

interface Fields {
  companyId: numStr;
  role: numStr;
  userId: numStr;
}

const Supports = () => {
  const [companyName, setCompanyName] = useRouteQuery('', 'companyName', String);
  const [currentCompanyId, setCurrentCompanyId] = useState<undefined | number | string>(undefined);
  const [usdot, setUSDOt] = useRouteQuery('', 'usdot', String);
  const [dispatcherName, setDispatcherName] = useRouteQuery('', 'dispatcherName', String);
  const [dispatcherId, setDispatcherId] = useState<string | undefined>('');

  useTagQuerySync(
    { en_US: 'Supports', zh_CN: '' },
    'supports',
    { companyName, currentCompanyId, usdot, dispatcherName, dispatcherId },
    {
      companyName: setCurrentCompanyId,
      currentCompanyId: setCurrentCompanyId,
      usdot: setUSDOt,
      dispatcherName: setDispatcherName,
      dispatcherId: setDispatcherId,
    },
  );

  const { data, isLoading, refetch, isFetching } = useDispatcher(dispatcherId);

  const onSubmit = async (values: Fields) => {
    if (currentCompanyId && dispatcherId) {
      values.role = 'support-user';
      values.companyId = currentCompanyId;
      values.userId = dispatcherId;
      await supports.supportPatchData(values);
      sendEvent(`Support Add Company Submit `, `Add Company in Support page`, `companyId`, '1');
      refetch();
      SearchResultForCompany('');
    }
  };

  const handleSearchSelect =
    (setter: (val: string | undefined) => void, nameSetter?: (val: string) => void) =>
    (val: any, { valId }: { valId: string }) => {
      setter(valId);
      nameSetter?.(val);
    };

  return (
    <div className="mainPage">
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, form, values, submitting, pristine, invalid }) => (
          <form onSubmit={handleSubmit}>
            <Space>
              <div>
                <Field
                  name="companyId"
                  render={({ input, meta }: { input: any; meta: any }) => (
                    <>
                      <SearchOptions
                        SearchResult={SearchResultForCompany}
                        value={companyName}
                        onSelect={handleSearchSelect(setCurrentCompanyId, setCompanyName)}
                        placeholder={'Search by company'}
                        SelectWidth={400}
                      />
                    </>
                  )}
                />
              </div>
              <div>
                <Field
                  name="companyId"
                  render={({ input, meta }: { input: any; meta: any }) => (
                    <>
                      <SearchOptions
                        SearchResult={SearchResultForCompanyUSDOT}
                        value={usdot}
                        onSelect={handleSearchSelect(setCurrentCompanyId, setUSDOt)}
                        placeholder={'Search by USDOT'}
                        SelectWidth={400}
                      />
                    </>
                  )}
                />
              </div>
              <div>
                <Field
                  name="userId"
                  render={({ input, meta }: { input: any; meta: any }) => (
                    <>
                      <SearchOptions
                        SearchResult={SearchResultForFindSupport}
                        value={dispatcherName}
                        onSelect={handleSearchSelect(setDispatcherId, setDispatcherName)}
                        placeholder="Support user"
                      />
                    </>
                  )}
                />
              </div>
              <div className="buttons" style={{ marginTop: '0px' }}>
                <Button
                  disabled={!(currentCompanyId && dispatcherId)}
                  type="primary"
                  htmlType="submit"
                >
                  Submit
                </Button>
              </div>
            </Space>
            <Button
              style={{ float: 'right', marginLeft: '15px' }}
              size={'large'}
              onClick={() => refetch()}
            >
              Refresh
            </Button>
          </form>
        )}
      />
      <SupportUserTable
        company={data}
        dispatcherId={dispatcherId}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={refetch}
      />
    </div>
  );
};

export default Supports;
